class FashionProductModal extends HTMLElement {
	constructor() {
		super();
		this.media = [];
		this.currentIndex = 0;
	}

	connectedCallback() {
		this.closeButton = this.querySelector('.fashion-product-modal__close');
		this.prevButtons = this.querySelectorAll('.fashion-product-modal__prev');
		this.nextButtons = this.querySelectorAll('.fashion-product-modal__next');
		this.mediaContainer = this.querySelector('.fashion-product-modal__media');
		this.thumbStrip = this.querySelector('.fashion-product-modal__thumbs');
		this.thumbBar = this.querySelector('.fashion-product-modal__thumbs-bar');
		this.thumbArrowLeft = this.querySelector('.fashion-product-modal__thumbs-arrow--left');
		this.thumbArrowRight = this.querySelector('.fashion-product-modal__thumbs-arrow--right');

		this.closeButton.onclick = () => this.hide();

		this.prevButtons.forEach((button) => {
			button.addEventListener('click', () => this.showImage(this.currentIndex - 1));
		});

		this.nextButtons.forEach((button) => {
			button.addEventListener('click', () => this.showImage(this.currentIndex + 1));
		});

		this.addEventListener('click', (e) => {
			if (e.target === this) this.hide();
		});
		if (this.thumbArrowLeft && this.thumbStrip) {
			this.thumbArrowLeft.onclick = (e) => {
				e.stopPropagation();
				this.thumbStrip.scrollBy({ left: -80, behavior: 'smooth' });
			};
		}
		if (this.thumbArrowRight && this.thumbStrip) {
			this.thumbArrowRight.onclick = (e) => {
				e.stopPropagation();
				this.thumbStrip.scrollBy({ left: 80, behavior: 'smooth' });
			};
		}
	}

	pauseBackgroundVideos() {
		document.querySelectorAll('.fashion-product-gallery-item video').forEach((video) => video.pause());
	}

	resumeBackgroundVideos() {
		const galleryItem = document.querySelectorAll('.fashion-product-gallery-item')[this.currentIndex];
		const video = galleryItem.querySelector('video');
		if (video) {
			video.play();
		}
	}

	setImages(media) {
		this.media = media;
		if (this.thumbStrip) {
			this.thumbStrip.innerHTML = media
				.map(
					(item, i) => `
                <img class="fashion-product-modal__thumb" data-idx="${i}" src="${item.thumbSrc}" alt="${item.alt || ''}" />
            `
				)
				.join('');
			this.thumbStrip.querySelectorAll('.fashion-product-modal__thumb').forEach((thumb) => {
				thumb.onclick = (e) => {
					e.stopPropagation();
					this.showImage(Number(thumb.dataset.idx));
				};
			});
		}
	}

	showImage(index) {
		if (!this.media.length) return;

		this.currentIndex = (index + this.media.length) % this.media.length;
		const item = this.media[this.currentIndex];
		this.mediaContainer.innerHTML = '';
		if (item.type === 'image') {
			const img = document.createElement('img');
			img.src = item.src;
			img.alt = item.alt || '';
			img.className = 'fashion-product-modal__img';
			this.mediaContainer.appendChild(img);
		} else if (item.type === 'video') {
			const galleryItems = document.querySelectorAll('.fashion-product-gallery-item');
			const galleryItem = galleryItems[this.currentIndex];

			const video = galleryItem.querySelector('video') || galleryItem.querySelector('deferred-media');
			const isDeferredMedia = galleryItem.querySelector('deferred-media');

			if (isDeferredMedia) {
				const deferredMediaButton = video.querySelector('button');
				deferredMediaButton?.click();
			}

			if (video) {
				const videoClone = video.cloneNode(true);
				videoClone.classList.add('fashion-product-modal__video');
				this.mediaContainer.appendChild(videoClone);

				const videoEls =
					videoClone.tagName === 'VIDEO' ? [videoClone] : Array.from(videoClone.querySelectorAll('video'));

				videoEls.forEach((v) => {
					v.setAttribute('controls', '');
					v.setAttribute('controlslist', 'nodownload');
					v.setAttribute('disablepictureinpicture', '');
					v.removeAttribute('muted');
					v.muted = false;
					v.volume = 1;
				});

				!isDeferredMedia && videoClone.play();
			}
		}

		this.pauseBackgroundVideos();
		this.show();
		if (this.thumbStrip) {
			this.thumbStrip.querySelectorAll('.fashion-product-modal__thumb').forEach((thumb, i) => {
				thumb.classList.toggle('fashion-product-modal__thumb--active', i === this.currentIndex);
			});
		}
		const newMediaElement = this.mediaContainer.firstElementChild;
		if (newMediaElement) {
			newMediaElement.setAttribute('tabindex', '-1');
			newMediaElement.focus({ preventScroll: true });
		}
	}

	hide() {
		if (this.mediaContainer) {
			this.mediaContainer.querySelectorAll('video').forEach((v) => {
				v.pause();
				v.currentTime = 0;
			});
			this.mediaContainer.innerHTML = '';
		}
		this.style.display = 'none';
		document.body.style.overflow = '';
		this.pauseBackgroundVideos();
	}

	show() {
		this.style.display = 'flex';
		document.body.style.overflow = 'hidden'; // Block scroll
	}
}

customElements.define('fashion-product-modal', FashionProductModal);

// Gallery integration
window.addEventListener('DOMContentLoaded', function () {
	const modal = document.getElementById('fashion-product-modal');
	const galleryItems = document.querySelectorAll('.fashion-product-gallery-item');
	if (!modal || !galleryItems.length) return;

	const media = Array.from(galleryItems).map((item) => ({
		type: item.dataset.type,
		src: item.dataset.type === 'image' ? item.dataset.src : '',
		videoSrc: item.dataset.type === 'video' ? item.dataset.videoSrc : '',
		thumbSrc: item.dataset.src,
		alt: item.dataset.alt,
		galleryItem: item
	}));
	modal.setImages(media);

	galleryItems.forEach((item, idx) => {
		item.addEventListener('click', () => modal.showImage(idx));
	});
});
